export enum FormFields {
  Password = 'password',
}

export interface FormValues {
  [FormFields.Password]?: string;
}
